import { render, staticRenderFns } from "./RgsModalAside.vue?vue&type=template&id=2c682ac8&"
import script from "./RgsModalAside.vue?vue&type=script&lang=ts&"
export * from "./RgsModalAside.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports